import { AppEntity } from '@app/icare/db/schema/common'
import { entityId } from '@pkg/db/schema'
import { z } from 'zod'

export const AdTeamId = entityId('adTeam')

export const AdTeamSchema = AppEntity.extend({
  id: AdTeamId.schema,
  name: z.string().min(1).default(''),
  entraGroupName: z.string().nullish(),
})

export type AdTeamIdType = typeof AdTeamId.Type

// Deterministic, cross-env-stable id for an Entra team group. Used by the
// R-adteams migration so its row always lands on the same id.
export const adTeamIdForEntraGroup = (entraGroupName: string): AdTeamIdType =>
  `adTeam_${entraGroupName}` as AdTeamIdType

// Canonical AD-teams with explicit display names — the single source the
// R-adteams repeatable migration upserts and the UI reads. Names are explicit
// (not munged from the group) so umlauts render correctly.
export const AD_TEAMS = [
  { entraGroupName: 'CARE_Team_Antibiose', name: 'Antibiose' },
  { entraGroupName: 'CARE_Team_Ernaehrung', name: 'Ernährung' },
  { entraGroupName: 'CARE_Team_Nord', name: 'Nord' },
  { entraGroupName: 'CARE_Team_Ost', name: 'Ost' },
  { entraGroupName: 'CARE_Team_Sued', name: 'Süd' },
  { entraGroupName: 'CARE_Team_Vertrieb', name: 'Vertrieb' },
  { entraGroupName: 'CARE_Team_West', name: 'West' },
] as const

const AD_TEAM_NAME_BY_GROUP = new Map<string, string>(AD_TEAMS.map(t => [t.entraGroupName, t.name]))

// Explicit display name for a CARE_Team_* group; falls back to the group suffix
// for groups not in AD_TEAMS.
export const teamNameForGroup = (entraGroupName: string): string =>
  AD_TEAM_NAME_BY_GROUP.get(entraGroupName) ?? entraGroupName.replace(/^CARE_Team_/, '').replaceAll('_', ' ')

export type AdTeam = z.infer<typeof AdTeamSchema>
